import React, { useEffect, useRef, useState } from "react";

function Popup({ customClass, customProps, children, handleClose = () => {} }) {
  const [returnContent, setReturnContent] = useState(true);

  const timeoutRef = useRef(null);

  useEffect(() => {
    if (returnContent) {
      document?.body?.setAttribute("style", "overflow-y: hidden;");
    } else {
      document?.body?.setAttribute("style", "overflow-y: unset;");
      timeoutRef.current = setTimeout(() => {
        // BuyNowSuccess used to omit handleClose; calling it crashed the WebView
        // ("handleClose is not a function"). Skip if a caller passed null.
        if (typeof handleClose === "function") handleClose();
      }, 300);
    }
    return () => clearTimeout(timeoutRef?.current);
  }, [returnContent]);

  return (
    <div
      className={
        returnContent
          ? "PopupWrapper blockSlide PopupWrapper__Show"
          : "PopupWrapper blockSlide PopupWrapper__Hide"
      }
    >
      <div
        onClick={() => setReturnContent(false)}
        className={
          returnContent ? "Backdrop Backdrop__Show" : "Backdrop Backdrop__Hide"
        }
      />
      <div
        className={
          returnContent
            ? `Popup Popup__Show ${customClass ? customClass : ""}`
            : `Popup Popup__Hide ${customClass ? customClass : ""}`
        }
        {...customProps}
      >
        {children}
      </div>
    </div>
  );
}

export default Popup;
